import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Translate from 'react-translate-component';

import { salaryIntervalTemplate } from 'helpers/fieldsHelpers';
import { DefinitionField } from 'components/common/fields/DefinitionField';
import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';

export default class WorkConditions extends Component {
    static propTypes = {
        project: PropTypes.object.isRequired
    };

    isEmptyConditions(project) {
        return !(
            project.amountMin || project.amountMax || project.bonuses || project.probation
            || project.workplace || project.schedule || project.worktype
        );
    }

    render() {
        const { project } = this.props;

        if (this.isEmptyConditions(project)) {
            return null;
        }

        const { amountMin, amountMax, currency = '', amountGrossNet = ''} = project;
        const amount = salaryIntervalTemplate(amountMin, amountMax);
        const salary = `${amount} ${currency} ${amountGrossNet && `(${amountGrossNet})`}`;

        return (
            <div>
                <DefinitionHeader translate="project.workConditions" iconType="laptop" />
                <div className="panel-view">
                    <DefinitionField translate="project.salary" text={ amount && salary } />
                    <DefinitionField translate="project.bonuses" text={ project.bonuses } />
                    { project.probation &&
                        <dl className="dl-horizontal">
                            <dt>
                                <Translate content="project.probation"/>
                            </dt>
                            <dd>
                                { project.probation + ' ' }
                                <Translate content="project.days" component="span"/>
                            </dd>
                        </dl>
                    }
                    <DefinitionField translate="project.workplace" text={ project.workplace  } />
                    <DefinitionField translate="project.schedule" text={ project.schedule } />
                    <DefinitionField translate="project.workType" text={ project.worktype } />
                </div>
            </div>
        );
    }
}
